import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Heart, MapPin, Hamburger, X } from 'lucide-react';
import './OurStory.css';

interface StoryEvent {
  date: string;
  title: string;
  description: string;
  icon: React.ElementType;
  location: string;
  media?: {
    type: 'image' | 'video';
    url: string;
    alt?: string;
  };
}

const storyEvents: StoryEvent[] = [
  {
    date: 'Agosto 2023',
    title: 'Como nos conhecemos',
    description: 'Nós conhecemos através do instagram, onde o Lorhan enviou uma mensagem para Bruna a elogiando após um repost de um story da academia. ',
    icon: Hamburger,
    location: 'Instagram',
    media: { type: 'image', url: require('../assets/story0.jpeg'), alt: 'Como nos conhecemos' },
  },
  {
    date: 'Agosto 2023',
    title: 'Primeiro encontro',
    description: 'Nós nos conhecemos em um jantar romantico em um restaurante acompanhado com um bom vinho e boas conversas.',
    icon: MapPin,
    location: 'La Vinicola Restaurante, Maringá',
    media: { type: 'image', url: require('../assets/story1.jpeg'), alt: 'Primeiro encontro' },
  },
  {
    date: 'Setembro 2023',
    title: 'Pedido de namoro',
    description: 'Lorhan tinha um plano de pedir Bruna em namoro em um jantar romantico em um gesto com uma sobremosa, porém o garçom se esqueceu, mas ele tinha um plano B, onde ele preparou um pedido de namoro dentro de um Kinder Ovo.',
    icon: Heart,
    location: 'Curitiba',
    media: { type: 'image', url: require('../assets/story2.jpeg'), alt: 'Pedido de namoro' },
  },
  {
    date: 'Outubro 2024',
    title: 'O pedido de casamento',
    description: 'Lorhan pediu Bruna em casamento durante uma viagem para Porto de Galinhas, ele planejou um momento perfeito durante um passeio de jangada na praia de Maracaipe.',
    icon: Heart,
    location: 'Praia de Maracaipe, Porto de Galinhas',
    media: { type: 'image', url: require('../assets/story3.jpeg'), alt: 'O pedido de casamento' },
  },
];

const OurStory: React.FC = () => {
  const [lightbox, setLightbox] = useState<null | { url: string; alt?: string }>(null);

  const openLightbox = (url: string, alt?: string) => setLightbox({ url, alt });
  const closeLightbox = () => setLightbox(null);

  return (
    <div className="our-story">
      <div className="story-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="story-hero-content"
          >
            <h1>Nossa História</h1>
            <p>Cada história de amor é linda, mas a nossa é a nossa favorita</p>
          </motion.div>
        </div>
      </div>

      <div className="story-timeline">
        <div className="container">
          <div className="timeline">
            {storyEvents.map((event, index) => {
              const IconComponent = event.icon;
              const isLeft = index % 2 === 0;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: isLeft ? -50 : 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className={`timeline-item ${isLeft ? 'left' : 'right'}`}
                >
                  {isLeft && (
                    <div className="timeline-thumbnail">
                      {event.media && event.media.type === 'image' ? (
                        <img
                          src={event.media.url}
                          alt={event.media.alt || ''}
                          onClick={() => openLightbox(event.media!.url, event.media!.alt)}
                        />
                      ) : event.media && event.media.type === 'video' ? (
                        <video controls src={event.media.url} title={event.media.alt || ''} />
                      ) : null}
                    </div>
                  )}
                  <div className="timeline-center">
                    <div className="timeline-icon">
                      <IconComponent />
                    </div>
                  </div>
                  <div className="timeline-card">
                    <div className="timeline-date">{event.date}</div>
                    <h3>{event.title}</h3>
                    <p>{event.description}</p>
                    <div className="timeline-location">
                      <MapPin className="location-icon" />
                      <span>{event.location}</span>
                    </div>
                  </div>
                  {!isLeft && (
                    <div className="timeline-thumbnail">
                      {event.media && event.media.type === 'image' ? (
                        <img
                          src={event.media.url}
                          alt={event.media.alt || ''}
                          onClick={() => openLightbox(event.media!.url, event.media!.alt)}
                        />
                      ) : event.media && event.media.type === 'video' ? (
                        <video controls src={event.media.url} title={event.media.alt || ''} />
                      ) : null}
                    </div>
                  )}
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>

      {lightbox && (
        <div className="story-lightbox" onClick={closeLightbox}>
          <button className="story-lightbox-close" onClick={closeLightbox} aria-label="Fechar imagem"><X /></button>
          <img
            className="story-lightbox-img"
            src={lightbox.url}
            alt={lightbox.alt || ''}
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}

      <div className="story-quote">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="quote-content"
          >
            <Heart className="quote-icon" />
            <blockquote>
              "O amor não consiste em olhar um para o outro, mas sim em olhar juntos para a mesma direção."
            </blockquote>
            <cite>- Bruna & Lorhan</cite>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default OurStory; 